import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { WebServiceService } from '../../../services/web-service.service';
import { Charts, HighchartsRendererService, isNullOrUndefined } from 'shared-library';
import { SIDENAV_DATA_MODULES, SIDENAV_CONTENTLIST_OPTIONS } from '../../../constants/side-nav.cnst';
import { WIDGET_TYPES, PAGETYPES, MAT_UI_TYPES } from '../../../constants/proj.cnst';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import * as L from 'leaflet';
import { UM_TABLE_CNST } from '../../vl-table/common/constants/table.cnst';
import { USER_MGMT_CNST } from '../../vl-table/common/constants/proj.constant';
import { WebWidgetPropertyFormService } from '../../widgetPropertyForms/web-widget-property-form.service';
import { chart } from 'highcharts';
import { FormBuilder, FormGroup } from '@angular/forms';


declare const WebFont: any;
@Component({
  selector: "lib-web-widget-filter",
  templateUrl: "./web-widget-filter.component.html",
  styleUrls: ["./web-widget-filter.component.scss"],
})
export class WidgetFilterComponent implements OnInit {
  @Input() widget!: any;
  @Input() page!: any;
  @Input() gridItemHeigthWidth!:{height:any,width:any};

  widgetTypes = WIDGET_TYPES;
  displayWidgetCharts:typeof Charts = Charts;
  pageTypes = PAGETYPES;
  matUiTypes = MAT_UI_TYPES;
  sideNavOptions = SIDENAV_DATA_MODULES;
  sideNavContentOptions = SIDENAV_CONTENTLIST_OPTIONS;
  widgetLabel: string = "";
  widgetId: string = "";
  placeholder: string = "";
  textColor: string = "";
  imageUploaderDefault = "../assets/images/image-placeholder.webp";
  dataSourceApiValues: any = { data: [], field: "" };
  selectedHeadFontFamily: string = 'Roboto';
  selectedBodyFamily: string = 'Roboto';
  applicationId = "";
  resizing = false;
  subscriptions: Subscription[] = [];
  map!: L.Map;
  tableConfig: any = {}
  tableData: any = [];
  dataTypes = UM_TABLE_CNST.CLICKABLE_DATA_TYPE;
  dummyForm!:FormGroup
  constructor(
    private sharedSrv: WebServiceService,
    private http: HttpClient,
    private highChartRenderService: HighchartsRendererService,
    private toasterService : ToastrService,
    private wFormService:WebWidgetPropertyFormService,
    private _fb:FormBuilder
  ) { }

  ngOnInit(): void {
    
    if(this.widget.widgetType==='map'){
      this.addMap()
    }
    if(this.widget.widgetType === this.widgetTypes.table) {
      if(this.widget.widgetConfig?.tableData ){
        let widgetTableConfig = this.widget.widgetConfig.tableConfig;
        this.tableConfig =  this.setTableConfig(USER_MGMT_CNST.LIST_NAME_MAPPING.CUSTOMER_LIST,true,widgetTableConfig.dataProperties);
        this.tableData = this.widget.widgetConfig.tableData;
      }else{

        this.tableConfig =  this.setTableConfig(USER_MGMT_CNST.LIST_NAME_MAPPING.CUSTOMER_LIST,false);
        this.tableData = [];
      }

    }
    this.dummyForm = this._fb.group({
      dummy:[]
    })
    if (!this.widget.widgetConfig) {
      this.widget.widgetConfig = {};
    }
    this.widget.widgetConfig["matUiType"] = this.widget.widgetConfig.hasOwnProperty("matUiType") ? this.widget.widgetConfig["matUiType"] : (this.widget.widgetType === this.widgetTypes.button ? this.matUiTypes.filled : this.matUiTypes.outlined);
    this.applicationId = this.sharedSrv.getApplicationData().application_id;
    this.subscriberEvents();
  }

  addMap(){
    let zoom =  this.widget.widgetConfig?.mapConfig?.zoom ?? 10
    setTimeout(() => {
      this.map = L.map(this.widget.widgetId+'_map').setView(this.widget.widgetConfig.coordinates, zoom);
      L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
        maxZoom: 20,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
      }).addTo(this.map);
      if(this.widget.widgetConfig.mapConfig && this.widget.widgetConfig.mapDataSourceData.length > 0)
      this.addGeoJsonLayer();
      setTimeout(() => {
      }, 1001);
    }, 1000);
  }

  subscriberEvents() {
    const dataSourceApiValues: any = this.sharedSrv.dataSourceApiValues$.subscribe((datavalues) => {
     
    });

    const mapSourceSubscription: any = this.highChartRenderService.displayWidgetDataConfigSubscriber$.subscribe((data: any) => {
      if (data) {
        this.addGeoJsonLayer();
      }
    })

    const themesSubscribption: any = this.sharedSrv.themesObj.subscribe((data: any) => {
      this.selectedHeadFontFamily = isNullOrUndefined(data?.headingFontStyle) ? "Roboto" : data?.headingFontStyle;
      this.selectedBodyFamily = isNullOrUndefined(data?.bodyFontStyle) ? "Roboto" : data?.bodyFontStyle
      this.loadFont();
    })

    this.wFormService.selectedTableConfig$.subscribe((value) => {
      if(value.key === this.widget.widgetId){
        this.widget.widgetConfig.tableConfig = value;
        if(this.widget.widgetConfig.tableData)
        this.tableConfig =  this.setTableConfig(USER_MGMT_CNST.LIST_NAME_MAPPING.CUSTOMER_LIST,true,value.dataProperties);
      }
    })

    this.subscriptions = this.subscriptions.concat([dataSourceApiValues,themesSubscribption,mapSourceSubscription]);
    
  }

  makeApiCall(source: any) {
    try {
      const apiUrl = source["datasource"];
      const method = source["method"];
      const payload = source["request-parameter"];
      const responseParameter = source["response-parameter"].label;
      const authApiUrl = source["auth-api-url"];
      const authType = source["auth"];
      const apiKey = source["api-key"];

      let headers = new HttpHeaders({
        "Content-Type": "application/json",
      });

      if (authType === "Bearer" && apiKey) {
        headers = headers.set("Authorization", `Bearer ${apiKey}`);
      }

      const requestData = { payload };

      if (authApiUrl && apiKey) {
        let headers = new HttpHeaders({
          "Content-Type": "application/json",
        });
        if (authType === "Bearer" && apiKey) {
          headers = headers.set("Authorization", `Bearer ${apiKey}`);
        } else if (authType === "Basic" && apiKey) {
          headers = headers.set("Authorization", "Basic ");
        }
        this.http.post(authApiUrl, headers).subscribe((responce) => { });
      } else {
        this.makeApiRequest(
          apiUrl,
          method,
          requestData,
          headers,
          responseParameter
        );
      }
    } catch (error: any) {
    }
  }

  makeApiRequest(
    apiUrl: string,
    method: string,
    requestData: any,
    headers: HttpHeaders,
    responseField?: any
  ): void {
    switch (method) {
      case "GET":
        this.http.get(apiUrl, { headers }).subscribe(
          (response) => {
            if (Array.isArray(response)) {
              this.dataSourceApiValues = {
                data: response,
                field: responseField,
              };
            } else {
            }
          },
          (error) => { }
        );
        break;
      case "POST":
        this.http.post(apiUrl, requestData, { headers }).subscribe(
          (response) => {
            if (Array.isArray(response)) {
              this.dataSourceApiValues = {
                data: response,
                field: responseField,
              };
            } else {
            }
          },
          (error) => { }
        );
        break;
      case "PUT":
        this.http.put(apiUrl, requestData, { headers }).subscribe(
          (response) => { },
          (error) => { }
        );
        break;
      case "DELETE":
        this.http.delete(apiUrl, { headers }).subscribe(
          (response) => { },
          (error) => { }
        );
        break;
      default:
        throw new Error("Invalid HTTP method");
    }
  }

  onClick(
    widgetId: string,
    widget: any,
  ) {
    let selectedPageData: any = this.sharedSrv.getSelectedPage()
    if ([PAGETYPES.loginPage,PAGETYPES.splashScreen,PAGETYPES.previewPage].includes(selectedPageData.pageType) || widget.open) {
      return;
    }
    this.sharedSrv.setSelectedOption(this.sideNavOptions.pages, true);

    let sectionIndex = this.page.forms.findIndex((form: any) => form.formId === widget?.formId);
    let widgetIndex = this.page.forms[sectionIndex].widgets.findIndex((widgetD: any) => widgetD.widgetId === widget.widgetId);

    if (this.page.pageId) {
      this.sharedSrv.setPagesExpansionPanelOpener({
        pageID: this.page.pageId,
        sectionIndex: sectionIndex,
        widgetIndex: widgetIndex.toString(),
      });
      this.sharedSrv.onMobileScreenDropUpdateData({
        data: widgetId,
        onClick: true,
        sectionIndex: sectionIndex,
        widgetIndex: widgetIndex,
        widgetMeta: widget,
      });
      this.sharedSrv.setSidenavContentlistOption(this.sideNavContentOptions.widget, true);
    }
  }

  getImageFile(binaryImage: string) {
    if (binaryImage == "image" || binaryImage == undefined) {
      return this.imageUploaderDefault;
    }else if(binaryImage.includes('mobiwise.s3')){
      return binaryImage;
    } else {
      let imageSrc = "data:image/png;base64,";
      imageSrc = imageSrc + binaryImage;
      return imageSrc;
    }
  }

  isRequired(validations: any[]): boolean {
    if (!validations || !Array.isArray(validations)) {
      return false;
    }
    for (const validation of validations) {
      if (validation.validation_type === "Required") {
        return true;
      }
    }
    return false;
  }

  getErrorMessage(validations: any[]): string {
    if (!validations || !Array.isArray(validations)) {
      return "";
    }
    for (const validation of validations) {
      if (validation.validation_type === "Required") {
        return validation.error_message;
      }
    }
    return "";
  }

  loadFont(): void {
    const selectedHeadFont = this.selectedHeadFontFamily.replace(/ /g, '+');
    const selectedBodyFont = this.selectedBodyFamily.replace(/ /g, '+');
    WebFont.load({
      google: {
        families: [`${selectedHeadFont}:wght@400`, `${selectedBodyFont}:wght@400`],
      },
    });
  }

  onResizeStart(event: any) {
    this.resizing = true; // Resize started
  }

  
  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }
  createGeoJSON(data: any[]) {
    const firstItemKeys = Object.keys(data[0]);
    const features = data.map((item) => {
      const properties: any = {};
      firstItemKeys.forEach((key) => {
        if (key !== 'location')
          properties[key] = item[key];
      });
      return {
        type: "Feature",
        properties: properties,
        geometry: {
          type: "Point",
          coordinates: [item.location[1], item.location[0]]
        }
      };
    });

    return {
      type: "FeatureCollection",
      features: features
    };
  }

  addGeoJsonLayer() {
    if (this.widget.widgetType === 'map') {
      let datas = this.updateMarkers(this.widget);
      const zoom = this.widget.widgetConfig?.mapConfig?.zoom
      let selectedMarker = this.widget.widgetConfig.mapConfig?.markerProps?.markerType
      let geojson: any
      if (datas.length > 0) {
        geojson = this.createGeoJSON(datas)
        this.map.eachLayer((layer: any) => {
          if (layer instanceof L.Marker || layer instanceof L.CircleMarker) {
            this.map.removeLayer(layer);
          }
        });
        L.geoJSON(geojson, {
          pointToLayer: (feature, latlng:any) => {
            return this.createMarker(feature, latlng, selectedMarker, this.widget);
          },
          onEachFeature: function (feature, layer: any) {
            let buildTd = '';
            for (let [key, value] of Object.entries(layer.feature.properties)) {
              buildTd += `<tr><td>${key}</td><td>${value}</td></tr>`
            }
            let popup = `<table>${buildTd}</table>`
            layer.bindPopup(popup)
          }
        }).addTo(this.map);
        var firstMarkerCoordinates = geojson.features[0].geometry.coordinates.reverse();
        this.map.setView(firstMarkerCoordinates, zoom);
        this.widget.widgetConfig.coordinates = firstMarkerCoordinates
      }
    }
  }

  createMarker(feature: any, latlng: any, selectedMarker: any, widget: any) {
    let marker;
    let mapConfig = widget.widgetConfig?.mapConfig
    let size = mapConfig?.markerProps?.size;
    let color = mapConfig?.markerProps?.color;
    let radius = mapConfig?.markerProps?.radius;
    switch (selectedMarker) {
      case 'circle':
        marker = L.circle(latlng, { radius: radius, color: color });
        break;
      case 'square':
        marker = L.marker(latlng, {
          icon: L.divIcon({
            className: 'custom-div-icon',
            html: `<div style="width: ${size}px; height: ${size}px; background-color: ${color};"></div>`
          })
        });
        break;
      case 'triangle':
        marker = L.marker(latlng, {
          icon: L.divIcon({
            className: 'custom-div-icon',
            html: `<div style="width: 0; height: 0; border-left: ${size / 2}px solid transparent; border-right: ${size / 2}px solid transparent; border-bottom: ${size}px solid ${color};"></div>`
          })
        });
        break;
      default:
        marker = L.marker(latlng);
    }
    return marker.addTo(this.map);
  }

  updateMarkers(selectedWidget: any) {
    const filteredLocations: any[] = [];
    let toasterShown = false;
    let mapConfig = selectedWidget.widgetConfig.mapConfig
    let mapSourceData = selectedWidget.widgetConfig.mapDataSourceData
    const contentKeys = mapConfig?.contentProps?.contentKeys;
    const latKey = mapConfig?.markerProps?.lat;
    const lonKey = mapConfig?.markerProps?.lon;

    if (mapSourceData?.length > 0) {
      mapSourceData.forEach((location: any) => {
        const filteredLocation: any = {};
        const locationArray: any[] = [];

        if (typeof location[latKey] !== 'number' || typeof location[lonKey] !== 'number') {
          if (!toasterShown) {
            this.toasterService.error('Invalid lat or lon key provided');
            toasterShown = true;
          }
        }

        locationArray.push(location[latKey]);
        locationArray.push(location[lonKey]);

        if (contentKeys) {
          contentKeys.forEach((key: string) => {
            if (location.hasOwnProperty(key)) {
              filteredLocation[key] = location[key];
            }
          });
        }
        filteredLocation['location'] = locationArray;
        filteredLocations.push(filteredLocation);
      });
    }
    return filteredLocations;
  }

  setTableConfig(moduleName: string,isWidgetData:boolean,tableDataProperties?:any) {

    let tableConfig: any = {}
    if(isWidgetData){
      tableConfig = UM_TABLE_CNST.TABLE_CONFIG;
     
    tableConfig['columns'] = this.convertToListOfObjects(tableDataProperties.tableHeaders,tableDataProperties.filterOptions);
    tableConfig['paginatorOptions'].limit = tableDataProperties.rowsPerPage;
    let limit = parseInt(tableDataProperties.rowsPerPage) ? parseInt(tableDataProperties.rowsPerPage) : tableDataProperties.rowsPerPage
    tableConfig['paginatorOptions'].dropdownOptions = [
    {
        "display": tableDataProperties.rowsPerPage,
        "value": tableDataProperties.rowsPerPage
    },
    {
        "display": tableDataProperties.rowsPerPage + tableDataProperties.rowsPerPage,
        "value": tableDataProperties.rowsPerPage + tableDataProperties.rowsPerPage
    },
] 
    this.tableData =  this.widget.widgetConfig.tableData.map((obj:any) => {
      const filteredObj: any = {};
      tableDataProperties.tableHeaders.forEach((key:string) => {
          if (obj.hasOwnProperty(key)) {
              filteredObj[key] = obj[key];
          }
      });
      return filteredObj;
    });
    }else{

    tableConfig = UM_TABLE_CNST.TABLE_CONFIG;
    tableConfig['columns'] = UM_TABLE_CNST.TABLE_COLUMNS[moduleName as keyof typeof UM_TABLE_CNST.TABLE_COLUMNS];
    }

    tableConfig['css'] = {
      tableClass: `table table-bordered`,
      theadClass: 'thead-light',
      tbodyClass: ''
    }
    console.log(tableConfig);
    return tableConfig;
  }


  convertToListOfObjects(keys: string[],Filter:boolean): any {
    return keys.map(key => ({
        name: key,
        dataType: "TEXT",
        jsonKey: { path: key },
        hasMultiColumnFilter: Filter,
        styles:{
          "header": {
              "width": "100px"
          }
      }
    }));
}

  handleOptionClick(e: any) {
    console.log(e,888);
  }
}
